<div class="po-wrapper">
  <po-page-default>
    <div class="row po-font-text-small">
      <po-breadcrumb [p-items]="[
                  { label: 'Pack', action: backPage },
                  { label: 'Items do pack' }
              ]">
      </po-breadcrumb>
    </div>
    <div class="po-row">
      <div class="po-xl-10 po-lg-10 po-md-9 po-sm-9">
        <p class="po-font-title">Pack</p>
      </div>
    </div>
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
      <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
        <div class="po-xl-10 po-lg-10 po-md-10 po-sm-10">
          <span class="po-text-color-01 po-font-text-large-bold">Descrição do pack</span>
        </div>
        <div class="po-xl-2 po-lg-2 po-md-2 po-sm-2 po-text-right">
          <span class="po-text-color-01 po-font-text-large-bold" style="cursor: pointer;" (click)="seeDescription()">
            <i *ngIf="!seeDescriptionPack" class="an-fill an-caret-circle-up" style="font-size: 20px;"></i>
            <i *ngIf="seeDescriptionPack" class="an-fill an-caret-circle-down" style="font-size: 20px;"></i>
          </span>
        </div>
      </div>
      <div class="po-row" *ngIf="seeDescriptionPack">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-font-text-large-bold">Sequência</span>
          <po-input [(ngModel)]="packNumber" name="input" p-disabled="true"></po-input>
        </div>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-font-text-large-bold">Descrição</span>
          <po-input [ngModel]="packDescription" name="input" p-disabled="true"></po-input>
        </div>
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-font-text-large-bold">Código de barras</span>
          <po-input [ngModel]="packBarCode" name="input" p-disabled="true"></po-input>
        </div>
      </div>
      <div class="startPosition"></div>
    </po-container>
    <po-container *ngIf="!nullItemList" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
      <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3; margin-bottom: 5px;">
        <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5">
          <span class="po-text-color-01 po-font-text-large-bold">Item do pack</span>
        </div>
        <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-text-right">
          <po-switch class="switch-remove" name="switch-remove" [(ngModel)]="switchRemove"
            p-label="Apagar ao ler código" p-label-on=" " p-label-off=" " [p-label-position]="labelPosition"
            (p-change)="activeRemoveItem()"></po-switch>
        </div>
      </div>
      <div [ngClass]="{ 'detail-pack-active': switchRemove }">
        <app-scanner (scannedData)="updateDetailPack($event)" [itemPackOrigin]="true"></app-scanner>
      </div>
      <div class="po-row po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-row po-md-3 po-sm-6 po-text-center tag-resume po-mt-1">
          <po-tag [p-value]="statusLabels[1] + ': ' + quantityOriginal" [p-type]="colorsStatusLabels[2]"></po-tag>
        </div>
        <div class="po-row po-md-3 po-sm-6 po-text-center tag-resume po-mt-1">
          <po-tag [p-value]="statusLabels[2] + ': ' + quantityIncremented" [p-type]="colorsStatusLabels[1]"></po-tag>
        </div>
        <div class="po-row po-md-3 po-sm-6 po-text-center tag-resume po-mt-1">
          <po-tag [p-value]="statusLabels[3] + ': ' + quantityRemoved" [p-type]="colorsStatusLabels[4]"></po-tag>
        </div>
        <div class="po-row po-md-3 po-sm-6 po-text-center tag-resume po-mt-1">
          <po-tag [p-value]="statusLabels[4] + ': ' + quantityTotal" [p-type]="colorsStatusLabels[3]"></po-tag>
        </div>
      </div>
    </po-container>
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2" style="margin-bottom: 50px;">
      <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3; margin-bottom: 5px;">
        <div class="po-xl-10 po-lg-10 po-md-10 po-sm-10">
          <span class="po-text-color-01 po-font-text-large-bold">Itens</span>
        </div>
        <div class="po-xl-2 po-lg-2 po-md-2 po-sm-2 po-text-right">
          <span class="po-text-color-01 po-font-text-large-bold" style="cursor: pointer;" (click)="seeDescriptionItens()">
            <i *ngIf="!seeDescriptionItemPack" class="an-fill an-caret-circle-up" style="font-size: 20px;"></i>
            <i *ngIf="seeDescriptionItemPack" class="an-fill an-caret-circle-down" style="font-size: 20px;"></i>
          </span>
        </div>
      </div>
      <div *ngIf="seeDescriptionItemPack">
        <app-card *ngIf="itemsPackList" [myData]="itemsPackList" [switchRemove]="activedRemoveItem"></app-card>
        <p *ngIf="itemsPackList == 0" class="po-mt-2 po-text-center po-font-text-large">Nenhum item vinculado!</p>
      </div>
    </po-container>

  </po-page-default>
</div>
<app-toaster></app-toaster>
<po-modal #poModalDuplicate [p-hide-close]="true" p-size="sm" [p-primary-action]="activeRemoveItemTemp"
  [p-secondary-action]="cancelRemoveItemTemp" p-title="Duplicidade">
  <div class="po-pr-2 po-pl-1 po-mb-2">
    <div class="po-row">
      <span class="po-font-text-large-bold po-text-color-07">{{ alertItemPack }}!</span>
    </div>
    <div class="po-row">
      <span class="po-font-text-large">Deseja remove-lo?</span>
    </div>
  </div>
</po-modal>